import React from 'react';
import {
  Grid,
  Paper,
  Typography,
  Box,
  LinearProgress
} from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const PerformanceStats = ({ metrics, performanceHistory }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Performance Metrics
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {[
              { label: 'Attendance Rate', value: metrics.attendance },
              { label: 'Loan Repayment', value: metrics.loanRepayment },
              { label: 'Risk Assessment', value: metrics.riskScore },
              { label: 'Discipline Score', value: metrics.discipline }
            ].map((metric) => (
              <Box key={metric.label}>
                <Typography variant="subtitle2">{metric.label}</Typography>
                <LinearProgress
                  variant="determinate"
                  value={metric.value}
                  sx={{
                    height: 10,
                    borderRadius: 5,
                    mt: 1,
                    mb: 1,
                    backgroundColor: '#e0e0e0'
                  }}
                />
                <Typography>{metric.value}%</Typography>
              </Box>
            ))}
          </Box>
        </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Performance Trends
          </Typography>
          <Box sx={{ height: 300 }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={performanceHistory}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="attendance" stroke="#8884d8" name="Attendance" />
                <Line type="monotone" dataKey="savings" stroke="#82ca9d" name="Savings" />
                <Line type="monotone" dataKey="repayment" stroke="#ffc658" name="Repayment" />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PerformanceStats;